<h4 mat-dialog-title>Are you sure you would like to decline this load?</h4>

<mat-dialog-content>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="btn btn-primary" (click)="confirmDecline()">Yes</button>
    <button class="btn btn-secondary" (click)="cancelDecline()">No</button>
</mat-dialog-actions>
